import React, { useEffect } from 'react';

import { ModePrevModel } from '../PrevMedia';

export const useClickOutside = (
    ref: React.MutableRefObject<HTMLDivElement>,
    handler: () => void,
    mode: ModePrevModel
) => {
    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (
                ref.current &&
                !ref.current.contains(event.target as HTMLElement) &&
                mode === null
            ) {
                handler();
                event.stopPropagation();
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref, handler, mode]);
};
